module.exports = {"320623100":"栟茶镇","320623101":"洋口镇","320623102":"苴镇","320623103":"长沙镇","320623104":"大豫镇","320623105":"掘港镇","320623107":"马塘镇","320623108":"丰利镇","320623109":"曹埠镇","320623110":"岔河镇","320623111":"双甸镇","320623112":"新店镇","320623113":"河口镇","320623114":"袁庄镇","320623400":"如东县经济开发区","320623401":"如东沿海经济开发区","320623402":"如东洋口港经济开发区","320623403":"如东东安科技园区","320623404":"如东沿海旅游经济开发区","320623405":"南通外向型农业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320623.json
// module id = 879
// module chunks = 0